// No navegador o leitor (pdf.js) lê direto da memória: nada é gravado.
export function pdfTemporario(dataUri: string): { uri: string; apagar: () => void } {
  return { uri: dataUri, apagar: () => {} };
}
